const fileMixin = {
  methods: {
    /*
     * 点击上传文件，触发事件
     * */
    onShowFileEditor() {
      this.dialogFileVisible = !0
      this.showUploadLoading = false
    },
    onBeforeRemoveFile() {},
    /*
     * 上传文件
     * @parma options {object} 上传参数
     * */
    async onUploadFile(options) {
      this.showUploadLoading = true
      const { file } = options
      await this.getDocFolderIDByType(file.name)
      const data = new FormData()
      data.append('fileName', file.name) // 文件名称
      data.append('currentNode', this.folderId) // 当前目录的id
      data.append('File', file)
      const { success, data: result } = await this.$http({
        data,
        url: this.$api.uploadFile,
        method: 'post',
        noCancelToken: true,
      })
      if (success) {
        for (let i = 0; i < this.localFileList.length; i++) {
          if (this.localFileList[i].name === file.name) {
            this.localFileList[i].fileId = result.documentVersionID
            this.localFileList[i].folderId = this.folderId
          }
        }
        this.showUploadLoading = false
      } else {
        this.$message({
          type: 'error',
          message: '上传失败!',
        })
        this.showUploadLoading = false
      }
    },
    /**
     * 文件发生改变时的回调
     * @param file {file} 文件
     */
    onChangeFile(file) {
      if (!this.localFileList.some(image => image.name === file.name)) {
        this.localFileList.push(file)
      }
    },
    /*
     * 移除文件
     * @parma file {object} 要删除的文件的信息
     * */
    async onRemoveFile(file) {
      const { success } = await this.$http({
        url: this.$api.removeFolderOrFile,
        params: {
          folderIDs: file.folderId,
          docIDs: file.fileId,
        },
      })
      this.$message({
        type: success ? 'success' : 'error',
        message: success ? '删除成功' : '删除失败',
      })
    },
    /*
     * 设置文件类型
     * @parma fileName {string} 文件名
     * return {string}  NormalUpload--普通文件 Model--模型
     * */
    setFileFolderType(fileName) {
      // 获取最后一个.的位置
      const index = fileName.lastIndexOf('.')
      // 获取后缀
      const ext = fileName.substr(index + 1)
      if (ext === 'rvt' || ext === 'nwd' || ext === ' rfa') {
        return 'Model'
      }
      return 'NormalUpload'
    },
    /*
     * 判断指定文件类型是否属于该文件类型
     * @parma fileName {string} 文件名
     * @parma fixedType {string} 指定文件类型
     * return {boolean}
     * */
    getFileType(fileName, fixedType) {
      const index = fileName.lastIndexOf('.')
      const ext = fileName.substr(index + 1)
      const FILE_TYPE_LIST = {
        PICTURE: ['bmp', 'png', 'jpeg', 'jpg'],
        MODEL: ['rvt', 'dwg', 'nwd'],
        EXCEL: ['xls', 'xlsx'],
        PDF: ['pdf'],
        WORD: ['doc', 'docx'],
        PPT: ['pptx', 'ppt'],
      }
      if (FILE_TYPE_LIST[fixedType].indexOf(ext) !== -1) {
        return true
      }
      return false
    },
    /*
     * 获取储存文件夹folderId
     * @parma fileName {string} 文件名
     * */
    async getDocFolderIDByType(fileName) {
      const { success, data } = await this.$http({
        url: this.$api.getUserDocFolderIDByType,
        params: {
          entityID: this.getQrcodeId(),
          folderType: this.setFileFolderType(fileName),
        },
        noCancelToken: true,
      })
      if (success) {
        this.folderId = data
      }
    },
    /*
     * 保存文件,html内容嵌入编辑器
     * */
    onSaveFile() {
      const fileList = this.localFileList
      for (let i = 0; i < fileList.length; i++) {
				const fileBox = document.createElement('div')
				fileBox.id = new Date().getTime().toString()
				fileBox.className = 'fileBox area__container'
        const fileName = fileList[i].name
        const fileDom = document.createElement('div')
        const fileNameSpan = document.createElement('span')
        fileNameSpan.innerHTML = fileName
        fileNameSpan.contentEditable = 'false' // 文字不可编辑
        this.setFileIcon(fileName, fileDom)
        fileDom.appendChild(fileNameSpan)
        fileDom.id = `${new Date().getTime().toString() + i}file`
        fileDom.className = 'file_item'
        fileDom.contentEditable = 'false' // 文字不可编辑
        fileDom.setAttribute('fileId', fileList[i].fileId)
        fileBox.appendChild(fileDom)
				this.beforeInsertElement(fileBox)
				// 在fileBox后面插入<p><br /></p>，避免光标无法定位
				if (i !== fileList.length - 1) {
					const brP = document.createElement('p')
					const br = document.createElement('br')
					brP.appendChild(br)
					this.beforeInsertElement(brP)
				}
			}
      this.dialogFileVisible = !1
    },
    /*
     * 设置文件的图片
     * @param fileName {string} 文件名
     * @parma fileDom {element} 文件dom
     * */
    setFileIcon(fileName, fileDom) {
      const el = fileDom
      const fileIcon = new Image()
      fileIcon.style.marginRight = '5px'
      let imageSrc = ''
      // pdf格式
      if (this.getFileType(fileName, 'PDF')) {
        imageSrc = require('@/assets/images/icon/icon_pdf.svg')
      } else if (this.getFileType(fileName, 'PICTURE')) {
        imageSrc = require('@/assets/images/icon/icon_image.svg')
      } else if (this.getFileType(fileName, 'MODEL')) {
        imageSrc = require('@/assets/images/icon/icon_model.svg')
      } else if (this.getFileType(fileName, 'EXCEL')) {
        imageSrc = require('@/assets/images/icon/icon_excel.svg')
      } else if (this.getFileType(fileName, 'WORD')) {
        imageSrc = require('@/assets/images/icon/icon_word.svg')
      } else if (this.getFileType(fileName, 'PPT')) {
        imageSrc = require('@/assets/images/icon/icon_ppt.svg')
      } else {
        imageSrc = require('@/assets/images/icon/icon_other.svg')
      }
      fileIcon.src = imageSrc
      el.appendChild(fileIcon)
    },
  },
}
export default fileMixin
